<template>
  <div>
    <TableVue :hideFooter="true" :hidePadding="true"
      id="timeSlotErrorTable">
      <thead>
        <tr>
          <th style="width: 120px"></th>
          <th>
            <b>{{ $t("basics.ressources") }}</b>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="error in timeSlotErrorParam">
          <td style="width: 120px">
            <span v-if="error.unavailable">
              <v-tooltip :text="$t('messages.ressourceUnavailableForThisDay')">
                <template v-slot:activator="{ props }">
                  <v-icon color="primary" class="mr-1" v-bind="props">mdi-alert</v-icon>
                </template>
              </v-tooltip>
            </span>
            <span v-if="error.holiday">
              <v-tooltip :text="$t('basics.holiday')">
                <template v-slot:activator="{ props }">
                  <v-icon color="primary" class="mr-1" v-bind="props">mdi-alert</v-icon>
                </template>
              </v-tooltip>
            </span>

            <span v-if="error.teacher_conflict && error.teacher_conflict.length > 0">
              <v-tooltip :text="error.unavailable
                ? $t('messages.teacherUnavailable')
                : $t('messages.teacherConflict')
                ">
                <template v-slot:activator="{ props }">
                  <v-icon class="mr-1" v-bind="props">mdi-account-box</v-icon>
                </template>
              </v-tooltip>
            </span>
            <span v-if="error.room_conflict && error.room_conflict.length > 0">
              <v-tooltip :text="error.unavailable
                ? $t('messages.roomUnavailable')
                : $t('messages.roomConflict')
                ">
                <template v-slot:activator="{ props }">
                  <v-icon class="mr-1" v-bind="props">mdi-desk</v-icon>
                </template>
              </v-tooltip>
            </span>
            <span v-if="error.vehicle_conflict && error.vehicle_conflict.length > 0">
              <v-tooltip :text="error.unavailable
                ? $t('messages.vehicleUnavailable')
                : $t('messages.vehicleConflict')
                ">
                <template v-slot:activator="{ props }">
                  <v-icon class="mr-1" v-bind="props">mdi-fire-truck</v-icon>
                </template>
              </v-tooltip>
            </span>
            <span v-if="error.equipment_conflict">
              <v-tooltip :text="$t('messages.equipmentConflict', {
                name:
                  error.equipment_conflict.name +
                  ' (' +
                  error.equipment_conflict.premise.name +
                  ')',
                num: error.equipment_conflict_info.used,
                count: error.equipment_conflict_info.available,
              })
                ">
                <template v-slot:activator="{ props }">
                  <v-icon class="mr-1" v-bind="props">mdi-tools</v-icon>
                </template>
              </v-tooltip>
            </span>
            <span v-if="error.is_temporary">
              <v-tooltip :text="$t('messages.temporaryTimeSlot')">
                <template v-slot:activator="{ props }">
                  <v-icon v-bind="props">mdi-clock-alert-outline</v-icon>
                </template>
              </v-tooltip>
            </span>
          </td>
          <td>
            <span v-if="error.teacher_conflict && error.teacher_conflict.length > 0">
              <v-chip style="margin-bottom: 2px" class="mr-1" v-for="teacher in error.teacher_conflict"
                @click="showEditUserToDate(error)">{{
                  teacher.full_name
                }} <i style="opacity: 0.6" v-if="error.not_booked" class="ml-1">({{ $t("constants.gast_dozent")
                }})</i></v-chip>
            </span>
            <span v-if="error.room_conflict && error.room_conflict.length > 0">
              <v-chip class="mr-1" style="margin-bottom: 2px" v-for="room in error.room_conflict">{{ room.name }} {{
                room.premise.name }}</v-chip>
            </span>
            <span v-if="error.holiday">
              {{ $t("messages.holidayOnThisDate") }}
            </span>
          </td>
        </tr>

        <tr v-if="!timeSlotErrorParam || timeSlotErrorParam.length == 0">
          <td colspan="400">
            <p>
              <i>{{ $t("messages.noItems") }}</i>
            </p>
          </td>
        </tr>
      </tbody>
    </TableVue>

    <LoadingScreenVue :loading="loading" />
  </div>
</template>

<script>

export default {
  name: "timeSlotErrorParamListComponent",

  props: ["timeSlotErrorParam"],

  data() {
    return {
      loading: false,
    };
  },


  computed: {
    isMobile() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return true;
        case "sm":
          return true;
        case "md":
          return false;
        case "lg":
          return false;
        case "xl":
          return false;
        case "xxl":
          return false;
        default:
          return false;
      }
    },
  },

  methods: {
  },

  mounted() {
  },
};
</script>
